import React from 'react'

import { Heading } from '../components/Heading';
import StockList from '../components/StockList';

export  function Stock() {

    const title = 'Catálogo';
    return (
        <>
          <Heading title={title}/>
          <div className="container">
            <StockList/>
          </div>
        </>
        
      )
  }
  
  export default Stock